import axios from 'axios';
import { apiPaths } from 'constants/path';
import { clAdminTokenHeader } from 'functions/apiFunctions';
import { UserInfoApi, UpdateFavoriteUserReqData, UpdateFavoriteUserApi, UserDetailApi } from 'models/CL/CLApiTypes';

class UserApi {
    private createUserListParams(
        page: number,
        searchField: string,
        searchKeyword: string,
        sortField: string,
        sortOrder: string,
        limit: number,
        isFavorite: boolean | null
    ): URLSearchParams {
        const params = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            searchField,
            searchKeyword,
            sortField,
            sortOrder,
        });

        if (isFavorite !== null) {
            params.set('isFavorite', String(isFavorite));
        }

        return params;
    }

    async getUserList(
        page: number,
        searchField: string,
        searchKeyword: string,
        sortField: string,
        sortOrder: string,
        limit: number,
        token: string,
        hospitalId: string,
        isFavorite: boolean | null
    ): Promise<UserInfoApi> {
        try {
            const params = this.createUserListParams(page, searchField, searchKeyword, sortField, sortOrder, limit, isFavorite);
            params.set('hospitalId', hospitalId);

            const response = await axios.get(`${apiPaths.CLAdminGetUserList}?${params.toString()}`, { headers: clAdminTokenHeader(token) });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getAllUserList(
        page: number,
        searchField: string,
        searchKeyword: string,
        sortField: string,
        sortOrder: string,
        limit: number,
        token: string,
        isFavorite: boolean | null
    ): Promise<UserInfoApi> {
        try {
            const params = this.createUserListParams(page, searchField, searchKeyword, sortField, sortOrder, limit, isFavorite);
            const response = await axios.get(`${apiPaths.CLAdminGetAllUserList}?${params.toString()}`, { headers: clAdminTokenHeader(token) });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getFavoriteUserList(token: string, hospitalId: string, sortField: string, sortOrder: string): Promise<UserInfoApi> {
        try {
            const response = await axios.get(
                `${apiPaths.CLGetFavoriteUserList}?isFavorite=true&hospitalId=${hospitalId}&sortField=${sortField}&sortOrder=${sortOrder}`,
                { headers: clAdminTokenHeader(token) }
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getUserDetail(userId: string, token: string, hospitalId?: string): Promise<UserDetailApi> {
        try {
            const hospitalQuery = hospitalId ? `?hospitalId=${hospitalId}` : '';
            const response = await axios.get(`${apiPaths.CLWebGetUserDetail}${userId}${hospitalQuery}`, { headers: clAdminTokenHeader(token) });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async updateFavoriteUser(rqData: UpdateFavoriteUserReqData, token: string): Promise<UpdateFavoriteUserApi> {
        try {
            const response = await axios.put(
                apiPaths.CLUpdateFavoriteUser,
                rqData,
                { headers: clAdminTokenHeader(token) }
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export const CLUserApi = new UserApi();
